import { FaHtml5, FaCss3Alt, FaPython, FaReact, FaNodeJs, FaGithubSquare, FaFigma, FaTrello, FaDatabase, FaSass, FaBootstrap } from "react-icons/fa";
import { SiJavascript, SiRedux, SiPostman, SiVisualstudiocode, SiJsonwebtokens, SiStyledcomponents, SiSqlite, SiLua } from "react-icons/si";
import { DiMongodb } from "react-icons/di";
import { AiOutlineConsoleSql } from "react-icons/ai";

const IconHTML = <FaHtml5 className="skill_icon"/>;
const IconCSS = <FaCss3Alt className="skill_icon"/>;
const IconPYTHON = <FaPython className="skill_icon"/>;
const IconREACT = <FaReact className="skill_icon"/>;
const IconNODE = <FaNodeJs className="skill_icon"/>;
const IconGIT = <FaGithubSquare className="skill_icon"/>;
const IconFIGMA = <FaFigma className="skill_icon"/>;
const IconTRELLO = <FaTrello className="skill_icon"/>;
const IconKNEX = <FaDatabase className="skill_icon"/>;
const IconSASS = <FaSass className="skill_icon"/>;
const IconJS = <SiJavascript className="skill_icon"/>;
const IconREDUX = <SiRedux className="skill_icon"/>;
const IconPOSTMAN = <SiPostman className="skill_icon"/>;
const IconVSCODE = <SiVisualstudiocode className="skill_icon"/>;
const IconSC = <SiStyledcomponents className="skill_icon"/>;
const IconJWT = <SiJsonwebtokens className="skill_icon"/>;
const IconSQLITE = <SiSqlite className="skill_icon"/>;
const IconMONGO = <DiMongodb className="skill_icon"/>;
const IconBOOTSTRAP = <FaBootstrap className="skill_icon"/>;
const IconSQL = <AiOutlineConsoleSql className="skill_icon"/>;
const IconLUA = <SiLua className="skill_icon"/>;

export const languageData = [
  {
    icon: IconHTML,
    title: "HTML",
  },
  {
    icon: IconCSS,
    title: "CSS",
  },
  {
    icon: IconJS,
    title: "JavaScript",
  },
  {
    icon: IconPYTHON,
    title: "Python",
  },
  {
    icon: IconSQL,
    title: "SQL",
  },
  {
    icon: IconLUA,
    title: "Lua",
  },
];

export const libData = [
  {
    icon: IconREACT,
    title: "React.js",
  },
  {
    icon: IconREDUX,
    title: "Redux.js",
  },
  {
    icon: IconNODE,
    title: "Node.js",
  },
  {
    icon: IconSC,
    title: "Styled",
  },
  {
    icon: IconKNEX,
    title: "Knex",
  },
  {
    icon: IconSQLITE,
    title: "SQLite3",
  },
  {
    icon: IconJWT,
    title: "JWT",
  },
  {
    icon: IconSASS,
    title: "SASS",
  },
  {
    icon: IconMONGO,
    title: "MongoDB",
  },
  {
    icon: IconMONGO,
    title: "Mongoose",
  },
  {
    icon: IconBOOTSTRAP,
    title: "Bootstrap",
  },
]

export const toolData = [
  {
    icon: IconGIT,
    title: "GitHub",
  },
  {
    icon: IconVSCODE,
    title: "VS Code",
  },
  {
    icon: IconTRELLO,
    title: "Trello",
  },
  {
    icon: IconFIGMA,
    title: "Figma",
  },
  {
    icon: IconPOSTMAN,
    title: "Postman",
  },
];